import React, { memo, useState } from "react";
import { Handle, Position } from "react-flow-renderer";
import UserService from "../../../services/UserService";
import { ReactComponent as AddItemIcon } from "../../../assets/icons/add_box.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/close.svg";
import { ReactComponent as LoopAllIcon } from "../../../assets/icons/loop_all.svg";
// import { ReactComponent as ListIcon } from '../../../assets/icons/list.svg'
import { ReactComponent as ListIcon } from "../../../assets/icons/add.svg";

import Wizard from "../../../domain/Devices/Wizards/Wizard";

//@ts-ignore
export default memo(({ data }) => {
  const customNodeStyles = {
    block: {
      background: "#7c1b1b",
      color: "#a2a9a8",
      borderRadius: "5px",
      minWidth: "10rem",
      //boxShadow: '-2px 1px 8px 1px #0f0f0f',
    },
    title: {
      margin: 0,
      fontSize: "14px",
      color: "#fff",
      fontFamily: "Catamaran",
      letterSpacing: "0.5px",
      padding: "10px 10px",
      textAlign: "center" as "center",
    },
    handleTopCenter: {
      width: "30%",
      height: "20px",
      borderTopRightRadius: "5px",
      borderTopLeftRadius: "5px",
      borderBottomLeftRadius: "unset",
      borderBottomRightRadius: "unset",
      top: "-25px",
      border: "unset",
      background: "#586565",
    },
  };

  return (
    <div style={customNodeStyles.block}>
      <Handle
        type="target"
        position={Position.Top}
        style={customNodeStyles.handleTopCenter}
      />
      <p style={customNodeStyles.title}>End</p>{" "}
    </div>
  );
});
